import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import { TranslationService } from '../../services/translation.service';
import { RouterhistoryService } from '../../services/routerhistory.service';
import { LogService } from '../../services/log.service';
import { throwError, Observable, of, empty } from 'rxjs'
import { catchError, map } from 'rxjs/operators';
import { Helper } from '../../classes/Helper';
import { ControlVariantFromString } from '../../types/ControlVariant';
import { SimulatorConfig , LanguageDefinition, SimulatorModuleConfig} from '../../classes';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { BsDropdownModule } from 'ngx-bootstrap';

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.scss']
})

export class ConfigComponent implements OnInit {

    cfg: SimulatorConfig;

    availableLanguages : Array<LanguageDefinition>;
    menuLoaded = false;
    @ViewChild("selectElement",{read: ElementRef}) selectElement: ElementRef;
    
    get languageLoaded(){
        return this.translator.getCurrentLanguage() != undefined;
    }
    maxSettings(){
        this.boilerForm.get('useBoiler').setValue('ecoTecExclusive');
        this.heatingCircuitsForm.get('heatingCircuitsNumber').setValue(9);
        this.solarSystemForm.get('solarSystem').setValue("two");
        this.bufferCylinderForm.get('bufferCylinder').setValue('allStor');
        this.ventilationForm.get('ventilation').setValue('yes');
        this.heatPumpForm.get('useHeatPump').setValue("aroTherm");
        this.heatPumpForm.get('aroThermNumber').setValue(7);
    }
    defaultSettings(){
        this.boilerForm.get('useBoiler').setValue('yes');
        this.boilerForm.get('ecoTecNumber').setValue(1);
        this.boilerForm.get('boilerNumber').setValue(1);
        this.heatingCircuitsForm.get('heatingCircuitsNumber').setValue(1);
        this.solarSystemForm.get('solarSystem').setValue("no");
        this.bufferCylinderForm.get('bufferCylinder').setValue('no');
        this.ventilationForm.get('ventilation').setValue('no');
        this.heatPumpForm.get('useHeatPump').setValue("no");
        this.heatPumpForm.get('aroThermNumber').setValue(1);
        this.heatPumpForm.get('flexoThermNumber').setValue(1);

    }
    debug(msg:string){
        this.log.debug("ConfigComponent: "+msg);
    }
    getTranslator() : TranslationService{
        return this.translator;
    }
    getConfig() : ConfigService{
        return this.config;
    }
    getSimulatorConfig(){
        return this.config.simulatorConfig;
    }
    constructor(
        private formBuilder : FormBuilder,
        private config : ConfigService,
        private log : LogService,
        private router : Router,
        private history : RouterhistoryService,
        private translator : TranslationService
        ) {

        this.availableLanguages = Array<LanguageDefinition>();

        this.debug('ConfigComponent constructed.');
        if(this.config.getLanguageDefinitions()){
            this.loadLanguages();
        }else{
            this.config.events$.subscribe(
                (event)=>{
                    if(event=='translationindex_loaded'){
                        this.loadLanguages();
                    }
                });
        }
        let autoStart = false;
        this.config.config$.subscribe(
            (config)=>{
                this.cfg = config;
                
                this.debug("config saved: "+config.getIdentifier());
                this.cfg.setIdentifier('config.component');
                this.cfg = config;
                this.setDefaultVariant();
    			
                if(this.history.getPreviousURL() == "/simulator"){
                    this.applyConfiguration(config);
                }else{
                    this.debug("not loading any config, coming from "+this.history.getPreviousURL());
                }
            },
            (error)=>{
                this.debug("Error getting config in ConfigComponent...");	
            }
        );

        this.setupForms();
        this.applyConfig();
    }
    loadLanguages(){
        this.availableLanguages.length=0;
        for(let lang of this.config.getLanguageDefinitions()){
            this.availableLanguages.push(lang);
        }
    }
    applyConfig(){
        if(this.config){
            if(this.config.simulatorConfig){
                let sc = this.config.simulatorConfig;
                let mod = sc.getModuleConfigByName('boiler');
                if(mod){
                    this.boilerForm.get('useBoiler').setValue(mod.getValue());
                    if(mod.getValue() == "yes"){
                        this.boilerForm.get("boilerNumber").setValue(mod.getParameter());
                    }
                    if(mod.getValue() == "ecoTecExclusive"){
                        this.boilerForm.get("ecoTecNumber").setValue(mod.getParameter());
                    }
                }

                mod = sc.getModuleConfigByName('heatingCircuits');
                if(mod){
                    this.heatingCircuitsForm.get('heatingCircuitsNumber').setValue(mod.getParameter());
                }
                mod = sc.getModuleConfigByName('heatPump');
                if(mod){
                    this.heatPumpForm.get('useHeatPump').setValue(mod.getValue());
                    if(mod.getValue() == "aroTherm"){
                        this.heatPumpForm.get('aroThermNumber').setValue(mod.getParameter());
                    }
                    if(mod.getValue() == "flexoTherm"){
                        this.heatPumpForm.get('flexoThermNumber').setValue(mod.getParameter());
                    }
                }

                mod = sc.getModuleConfigByName('solarSystem');
                if(mod){
                    this.solarSystemForm.get('solarSystem').setValue(mod.getValue());
                }
                mod = 
                mod = sc.getModuleConfigByName('ventilation');
                if(mod){
                    this.ventilationForm.get('ventilation').setValue(mod.getValue());
                }

                mod = sc.getModuleConfigByName('bufferCylinder');
                if(mod){
                    this.bufferCylinderForm.get('bufferCylinder').setValue(mod.getValue());
                }
                mod = sc.getModuleConfigByName('regelung');
                if(mod){
                      this.regelungsForm.get('regelung').setValue(mod.getParameter());
                }
            }
        }
    }

        @HostListener('window:keydown', ['$event'])
        keyEvent(ke: KeyboardEvent) {
            switch(ke.keyCode){
                case 49:{ // taste 1
                    this.maxSettings();
                    ke.preventDefault();
                    break;
                }
                case 50:{ // taste 2
                    this.maxSettings();
                    if(this.moduleAvailable('devices') && this.subModuleAvailable('devices','vrc720f')){
                    }
                    ke.preventDefault();
                    break;
                }
                case 51:{ // taste 3
                    this.defaultSettings();
                    ke.preventDefault();
                    break;
                }
                case 73: // taste 'i'
                {
                    this.startInstallation(ke);
                    ke.preventDefault();
                    break;
                }
                case 13: // taste 'enter'
                {
                    this.startSimulation(ke);
                    ke.preventDefault();
                    break;
                }
                default:{}
            }
            this.debug("Key Pressed: "+ke.keyCode);
            
    }
    moduleAvailable(name: string):boolean{

        if(this.cfg){
            return this.cfg.moduleAvailable(name);
        }

        return false;
    }

    subModuleAvailable(name : string,subname : string):boolean{

        if(this.cfg){
            return this.cfg.subModuleAvailable(name,subname);
        }

        return false;
    }


    applyConfiguration(config: SimulatorConfig){
        this.debug("loading simulator config.");
        let modules = config.getModuleConfigs();
        this.debug("loaded " + modules.length + " modules.");
        for(let mod of modules){

            if(!this.subModuleAvailable(mod.getName(),mod.getValue())){
                this.debug("module unavailable!: "+mod.getName()+ ":"+mod.getValue());
            }else{
                switch(mod.getName()){
                    case 'boiler':{

                        this.boilerForm.get('useBoiler').setValue(mod.getValue());
                        switch(mod.getValue()){
                            case 'ecoTecExclusive':{

                                this.boilerForm.get('ecoTecExclusiveNumber').setValue(mod.getParameter());
                                break;
                            }
                            case 'yes':{

                                this.boilerForm.get('boilerNumber').setValue(mod.getParameter());
                                break;
                            }
                            default:{}
                        }
                        break;
                    }
                    case 'heatingCircuits':{

                        this.heatingCircuitsForm.get('heatingCircuitsNumber').setValue(mod.getParameter());
                        break;
                    }
                    case 'heatPump':{
                        this.heatPumpForm.get('useHeatPump').setValue(mod.getValue());
                        switch(mod.getValue()){
                            case 'aroTherm':{
                                this.heatPumpForm.get('aroThermNumber').setValue(mod.getParameter());
                                break;
                            }
                            case 'flexoTherm':{
                                this.heatPumpForm.get('flexoThermNumber').setValue(mod.getParameter());
                                break;
                            }
                            default:{}
                        }
                    }
                    case 'solarSystem':{
                        this.solarSystemForm.get('solarSystem').setValue(mod.getValue());
                        break;
                    }
                    case 'bufferCylinder':{
                        this.bufferCylinderForm.get('bufferCylinder').setValue(mod.getValue());
                        break;
                    }
                    case 'ventilation':{
                        this.ventilationForm.get('ventilation').setValue(mod.getValue());
                        break;
                    }
                    default:{
                        break;
                    }
                }
            }

        }
    }
    setDefaultVariant(){
        console.log("setting default variant.");
        let c = this.cfg.getVariant();
        if(c){
            if(c != 'N/A'){
                console.log("not setting default variant: variant already set to "+c);
                return;
            }else{
                let variants = ['PanterCondens','TigerCondens','vrc720','vrc720f','AI','ecoTEC exclusive','ecoTEC plus','ThemaFast','ThemaFastMondens','IsoTwinMCondens','ThemaCondens','ThemaMCondens','ThemaPlus','ThemaFastCondens','ThemaPlusCondens','IsoMax','IsoMaxCondens','IsoTwin','IsoFast','IsoFastCondens','IsoTwinCondens','MasterCondens','N/A'];
                for(let variant of variants){

                    if(this.subModuleAvailable('devices',variant)){
                        console.log("Setting variant to: "+variant);
                        this.cfg.setVariant(ControlVariantFromString(variant));
                        return;
                    }else{
                        //console.log("Not available: "+variant);
                    }
                }
            }

        }
    }
    ngOnInit() {
        this.setDefaultVariant();
    }


    setupForms(){
        this.setupBoilerForm();
        this.setupHeatingCircuitsForm();
        this.setupHeatPumpForm();
        this.setupSolarSystemForm();
        this.setupBufferCylinderForm();
        this.setupVentilation();
        this.setupRegelungsForm();
        this.setupLanguageForm();
    }

/****************
**
**
** EcoTecExclusive Peripherals
**
**
****************/

regelungsForm : FormGroup;
setupRegelungsForm(){
    this.regelungsForm = this.formBuilder.group({
        regelung:['standalone']
    });
}

/****************
**
**
** Heating-Circuits-Form
**
**
****************/

heatingCircuitsForm : FormGroup;
setupHeatingCircuitsForm(){
    this.heatingCircuitsForm = this.formBuilder.group({
        heatingCircuitsNumber:['1',''],
    });
}


/****************
**
**
** Boiler-Form
**
**
****************/

boilerForm : FormGroup;
setupBoilerForm(){
    this.boilerForm = this.formBuilder.group({
        useBoiler:['yes',''],
        boilerNumber:['1',''],
        ecoTecNumber:['1',''],
    });
    
    this.boilerForm.get('useBoiler').valueChanges.subscribe(
        (useBoilerValue)=>{
            switch(useBoilerValue){
                case 'no':{
                    if(this.heatPumpForm.get('useHeatPump').value == 'no'){
                        this.heatingCircuitsForm.get('heatingCircuitsNumber').setValue('1');
                        this.solarSystemForm.get('solarSystem').setValue('no');
                        this.bufferCylinderForm.get('bufferCylinder').setValue('no');
                    }
                    break;
                }
                default:{

                }
            }
        }
        );

}


/****************
**
**
** Heatpump-Form
**
**
****************/

heatPumpForm : FormGroup;
setupHeatPumpForm(){
    this.heatPumpForm = this.formBuilder.group({
        useHeatPump:['no',''],
        aroThermNumber:['1',''],
        flexoThermNumber:['1',''],
    });

    this.heatPumpForm.get('useHeatPump').valueChanges.subscribe(
        (useHeatPumpValue)=>{
            switch(useHeatPumpValue){
                case 'no':{
                    if(this.boilerForm.get('useBoiler').value == 'no'){
                        this.heatingCircuitsForm.get('heatingCircuitsNumber').setValue('1');
                        this.solarSystemForm.get('solarSystem').setValue('no');
                        this.bufferCylinderForm.get('bufferCylinder').setValue('no');
                    }
                    break;
                }
                case 'recoCompact':{
                    this.ventilationForm.get('ventilation').setValue('yes');
                    break;
                }
                default:{
                    this.boilerForm.get('boilerNumber').setValue('1');
                    this.boilerForm.get('ecoTecNumber').setValue('1');
                }
            }
        }
        );
}
/****************
**
**
** Solar-System-Form
**
**
****************/




solarSystemForm : FormGroup;
setupSolarSystemForm(){
    this.solarSystemForm = this.formBuilder.group({
        solarSystem:['no',''],
    });

}


bufferCylinderForm : FormGroup;
setupBufferCylinderForm(){
    this.bufferCylinderForm = this.formBuilder.group({
        bufferCylinder:['no',''],
    });
}



/****************
**
**
** Ventilation-Form
**
**
****************/

ventilationForm : FormGroup;
setupVentilation(){
    this.ventilationForm = this.formBuilder.group({
        ventilation:['no',''],
    });

}
/****************
**
**
** Language-Form
**
**
****************/

languageForm : FormGroup;
setupLanguageForm(){
    this.languageForm = this.formBuilder.group({
        language:['de',''],
    });
    if(this.config.complete()){
        this.configureLanguageForm();
    }else{
        this.config.events$.subscribe(
            (event)=>{
                if(event == 'all_files_loaded'){
                    this.configureLanguageForm();
                }
            }
        );
    }
    
}
configureLanguageForm(){
    
    this.languageForm.get('language').valueChanges.subscribe(
    languageId => {
        this.config.setLanguage(languageId);
        this.config.setUiLanguage(languageId);
        let v = this.heatingCircuitsForm.get('heatingCircuitsNumber').value;
        this.heatingCircuitsForm.reset({'heatingCircuitsNumber':v});
    }
    );
    this.languageForm.get('language').setValue(this.config.getCurrentLanguage());
    this.config.setUiLanguage(this.config.getCurrentLanguage());

}
isEnabled(section:any,module?:any){
    let val = this.isDisabled(section,module);
    if( val === null|| val === undefined){
        return true;
    }
    return false;
}

createModuleConfig(){
    let configs = new Array<SimulatorModuleConfig>();
    if(this.moduleAvailable('boiler')){
        

        let boilerValue = this.boilerForm.get('useBoiler').value;
        if(!this.subModuleAvailable('boiler',boilerValue)){
            this.debug("boiler has value that should not be available: " + boilerValue);
        }else{
            let boilerConfig = new SimulatorModuleConfig({});
            boilerConfig.setName('boiler');
            boilerConfig.setValue(boilerValue);
            if(!this.isEnabled('useBoiler','boilerValue')){
                boilerConfig.setAvailable(false);
                this.debug("boiler config is not available");
            }else{
                if(boilerValue == 'yes'){
                    let boilerNumber = this.boilerForm.get('boilerNumber').value;
                    let available = this.isEnabled('useBoiler','yes');
                    
                    boilerConfig.setAvailable(available);
                    
                    boilerConfig.setParameter(boilerNumber);
                }
                if(boilerValue == 'ecoTecExclusive'){
                    let ecoTecNumber = this.boilerForm.get('ecoTecNumber').value;
                    let available = this.isEnabled('ecoTecNumber',ecoTecNumber);
                    boilerConfig.setAvailable(available);
                    boilerConfig.setParameter(ecoTecNumber);
                }
            }
            this.debug("Pushing "+boilerConfig.toString());
            configs.push(boilerConfig);
        }

    }else{
        let config = new SimulatorModuleConfig();
        config.setName('boiler');
        config.setAvailable(false);
        configs.push(config);
    }


    if(this.moduleAvailable('heatingCircuits')){
        let heatingCircuitsConfig = new SimulatorModuleConfig();
        heatingCircuitsConfig.setName('heatingCircuits');

        if(this.isEnabled('heatingCircuits')){
            heatingCircuitsConfig.setAvailable(true);
        }
        heatingCircuitsConfig.setParameter(this.heatingCircuitsForm.get('heatingCircuitsNumber').value);
        configs.push(heatingCircuitsConfig);
        this.debug(heatingCircuitsConfig.toString());
    }else{
        let config = new SimulatorModuleConfig();
        config.setName('heatingCircuits');
        config.setAvailable(true);
        config.setParameter(1);
        configs.push(config);
    }



    if(this.moduleAvailable('heatPump')){

        let heatpumpConfig = new SimulatorModuleConfig();
        let useHeatpumpVal = this.heatPumpForm.get('useHeatPump').value;
        
        heatpumpConfig.setName("heatPump");
        heatpumpConfig.setValue(useHeatpumpVal);
        if(!this.subModuleAvailable('heatPump',useHeatpumpVal)){
            this.debug("value is not available: "+useHeatpumpVal);
        }else{
            switch(useHeatpumpVal){
                case 'aroTherm':{
                    let num = this.heatPumpForm.get('aroThermNumber').value;
                    heatpumpConfig.setAvailable(this.isEnabled('aroThermNumber',num));
                    heatpumpConfig.setParameter(num);
                    break;
                }
                case 'flexoTherm':{
                    let num = this.heatPumpForm.get('flexoThermNumber').value;
                    heatpumpConfig.setAvailable(this.isEnabled('flexoTherm',num));
                    heatpumpConfig.setParameter(num);
                    break;
                }
                default:{
                    heatpumpConfig.setAvailable(this.isEnabled(useHeatpumpVal));
                }
            }
        }

        this.debug("adding "+heatpumpConfig.toString());
        configs.push(heatpumpConfig);
    }else{
        let config = new SimulatorModuleConfig();
        config.setName('heatPump');
        config.setAvailable(false);
        configs.push(config);
    }



    if(this.moduleAvailable('solarSystem')){
        let solarConfig = new SimulatorModuleConfig();
        let solarSystemValue = this.solarSystemForm.get('solarSystem').value;
        solarConfig.setName('solarSystem');
        solarConfig.setValue(solarSystemValue);
        if(!this.subModuleAvailable('solarSystem',solarSystemValue) || !this.isEnabled('solarSystem',solarSystemValue)){
            this.debug("SolarSystem has an value that is unavailable: "+solarSystemValue);
        }else{
            
            solarConfig.setAvailable(true);
        }
        this.debug("adding "+ solarConfig.toString());
        configs.push(solarConfig);
    }else{
        let config = new SimulatorModuleConfig();
        config.setName('solarSystem');
        config.setAvailable(false);
        configs.push(config);
    }


    if(this.moduleAvailable('ventilation')){
        let ventilationConfig = new SimulatorModuleConfig();
        let ventilationValue = this.ventilationForm.get('ventilation').value;
        ventilationConfig.setName('ventilation');
        ventilationConfig.setValue(ventilationValue);
        if(!this.subModuleAvailable('ventilation',ventilationValue) || !this.isEnabled('ventilation',ventilationValue)){
            this.debug("ventilation has an value that is not available: "+ventilationValue);
        }else{
            ventilationConfig.setAvailable(true);
        }
        this.debug("adding "+ventilationConfig.toString());
        configs.push(ventilationConfig);

    }else{
        /**
            Lüftungs-Konfiguration für den Fall mit reinnehmen, dass recoCompact wählbar ist aber 
            Lüftung nicht.
        **/
        if(this.moduleAvailable('heatPump') && this.subModuleAvailable('heatPump','recoCompact') && this.heatPumpForm.get('useHeatPump').value == 'recoCompact'){
            let config = new SimulatorModuleConfig();
            config.setName('ventilation');
            config.setAvailable(true);
            config.setValue('yes');
            configs.push(config);
        }else{
            let config = new SimulatorModuleConfig();
            config.setName('ventilation');
            config.setAvailable(false);
            configs.push(config);
        }
    }

    if(this.moduleAvailable('bufferCylinder')){
        let bufferConfig = new SimulatorModuleConfig();
        bufferConfig.setName('bufferCylinder');
        let bufferValue = this.bufferCylinderForm.get('bufferCylinder').value;
        bufferConfig.setValue(bufferValue);
        if(!this.subModuleAvailable('bufferCylinder',bufferValue) || !this.isEnabled('bufferCylinder',bufferValue)){
            this.debug("bufferCylinder has an value that is not available: "+bufferValue);
        }else{
            bufferConfig.setAvailable(true);
        }
        this.debug("adding "+ bufferConfig.toString());
        configs.push(bufferConfig);

    }else{

        let config = new SimulatorModuleConfig();
        config.setName('bufferCylinder');
        config.setAvailable(false);
        configs.push(config);
    }
    if(this.moduleAvailable('regelung')){
        let regelungValue = this.regelungsForm.get('regelung').value;
        configs.push(new SimulatorModuleConfig().setName('regelung').setAvailable(true).setParameter(regelungValue));
    }

    console.log(JSON.stringify(configs));
    return configs;
}
eventCount=0;
startInstallation($event){
    this.startSimulation($event,true);
}

startSimulation($event?,showInstallation?:boolean){
    if($event){
        $event.preventDefault();
    }
    if(showInstallation){
        this.config.config.showInstallation(true);
    }else{
        this.config.config.showInstallation(false);
    }
    this.config.config.setModuleConfigs(this.createModuleConfig());
    let lang = this.languageForm.get('language').value;
    this.config.setLanguage(lang);
    this.config.config.setConfigured(true);
    
    this.router.navigate(['simulator']);
}


isDisabled(inputName,sub):boolean{
    let useBoilerVal = this.boilerForm.get('useBoiler').value;
    let boilerNum = this.boilerForm.get('boilerNumber').value;
    let ecoTecNumber = this.boilerForm.get('ecoTecNumber').value;
    let useHeatpumpVal = this.heatPumpForm.get('useHeatPump').value;
    let bufferCylinderVal = this.bufferCylinderForm.get('bufferCylinder').value;
    let useSolarVal = this.solarSystemForm.get('solarSystem').value;
    let num = parseInt(sub);
    var enabled = null;
    var disabled = true;
    switch(inputName){
        case 'useBoiler':{
            return ;
        }
        case 'boilerNumber':{
            if(!num || num == 1){
                return enabled;
            }
            return (useHeatpumpVal!="no")?disabled:enabled;


        }
        case 'ecoTecNumber':{
            if(!num || num == 1){
                return enabled;
            }
            return (useHeatpumpVal!="no")?disabled:enabled;

        }
        case 'useHeatPump':{
            if(sub == "no"){
                return enabled;
            }
            if( sub == "geoTherm" && bufferCylinderVal == "allStor"){
                return disabled;
            }
            if((useBoilerVal == "yes" && parseInt(boilerNum) > 1)||(useBoilerVal == "ecoTecExclusive" && parseInt(ecoTecNumber) > 1)){
                return disabled;
            }else{
                return enabled;
            }

        }
        
        case 'ventilation':{
            if(sub == "no" && useHeatpumpVal == "recoCompact"){
                return disabled;
            }
            return enabled;
        }
        
        case 'solarSystem':{
            if(bufferCylinderVal == 'yes' && sub != "no"){
                return disabled;
            }
            if(bufferCylinderVal == 'allStor' && sub == "one"){
                return disabled;
            }
            let retVal = ((sub != "no") && (useBoilerVal == "no") && (useHeatpumpVal == "no"))?disabled:enabled;
            return retVal;
        
        }
        
        case 'heatingCircuits':{
            if(useHeatpumpVal == "no" && useBoilerVal == "no"){
                return disabled;
            }
            return enabled;
        }
        
        case 'bufferCylinder':{
            // boiler = no
            // heatpump = no
            // => nur "no" wählbar
            if(useBoilerVal == "no" && useHeatpumpVal == "no"){
                return ((sub == "no")?enabled:disabled);
            }
            switch(useSolarVal){
                case 'no':{
                    break;
                }
                case 'one':{
                    if(["yes","allStor"].includes(sub)){
                        return disabled;
                    }
                    break;
                }
                case 'two':{
                    if ( sub == "yes"){
                        return disabled;
                    }
                    break;
                }
            }
            return (sub == "allStor" && useHeatpumpVal == "geoTherm")?disabled:enabled;
        }
        
        case 'startButton':{
            if(!this.config.complete() || ( useBoilerVal == "no" && useHeatpumpVal == "no" && this.ventilationForm.get('ventilation').value == "no") ){
                return disabled;
            }
            return enabled;
        }
        
        default:{
            return enabled;
        }
    }

}

}
